import { warn } from '../../jsCore/application/console'
import { TYPES } from '../../jsCore/organizedByType/actions/actionCounterProviderActions'
import { fetchPostMetadata } from '../../jsCore/providers/actionCounter/currentPostActionCounterProvider'
import { fetchCountersIndependent } from '../../jsCore/providers/actionCounter/actionCounterBaseProvider'
const { DATA_RECEIVED } = TYPES

function getPostData() {
  return (dispatch, getState) =>
    fetchPostMetadata()
      .then(state =>
        dispatch({
          type: DATA_RECEIVED,
          state,
        })
      )
      .catch(warn)
}

function getSpecificPostReadsData(postId) {
  return (dispatch, getState) =>
    fetchCountersIndependent(`Post_${postId}`)
      .then(state => {
        state.postId = postId
        return dispatch({
          type: DATA_RECEIVED,
          state,
        })
      })
      .catch(warn)
}

export const postMetadataActions = {
  fetchData: getPostData,
  fetchSpecificData: getSpecificPostReadsData,
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/post_metadata/postMetadataActions.js